import BaseApiCall from "./BaseApiCall";

//adjuste
export const loadTicketHead = async () => {
    try {
        const response = await BaseApiCall.post('/dy/load-ticket-head');
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const loadDynamicForm = async (orgId) => {
    try {
        const response = await BaseApiCall.post('/dy/load', orgId);
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const loadCustomerForm = async () => {
    try {
        const response = await BaseApiCall.post('/dy/load-customer-form');
        return response.data;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const addCustomerForm = async (payload) => {
    try {
        const response = await BaseApiCall.post('/dy/add-customer-form', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

export const addDynamicForm = async (payload) => {
    try {
        const response = await BaseApiCall.post('/dy/add-dynamic-form', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

export const loadDynamicFormByType = async (payload) => {
    try {
        const response = await BaseApiCall.post("/dy/get-by-org", payload);
        return response.data;
    } catch (error) {
        console.error("Error syncing type selection:", error);
    }
};

export const handleSync = async (orgId, formId) => {
    try {
        const payload = {
            organizationId: orgId,
            formId: formId,
        };
        const response = await BaseApiCall.post('/dy/sync', payload);
        if (!response.ok) {
            throw new Error('Failed to sync the form');
        }
        const result = await response.json();
    } catch (error) {
        console.error('Error syncing form:', error);
        throw new Error(error);
    }
};
